import { Component, Prop, PropSync, Ref, Vue } from 'vue-property-decorator'
import {
    initialPatientFusionDataState,
    PatientFusionDataState
} from '@/modules/RegistryModule/views/editCase/modals/patient-fusion/data/patient-fusion-data.model'
import PatientSearcherComponent from '@/components/common/searcher/components/patient/patient-searcher.vue'
import PatientHeaderCard from '@/components/patient/modalPatientFusion/PatientHeaderCard.vue'
import PatientIdentifiersCard from '@/components/patient/modalPatientFusion/PatientIdentifiersCard.vue'
import PatientPersonalDataCard from '@/components/patient/modalPatientFusion/PatientPersonalDataCard.vue'
import PatientAddressInfoCard from '@/components/patient/modalPatientFusion/PatientAddressInfoCard.vue'
import ModalRepeatedPatients from '@/modules/RegistryModule/views/editCase/modals/ModalRepeatedPatients.vue'
import patientResource from '@/api/resources/PatientResource'
import { PromiseUtils } from '@/shared/util/promise-utils'
import { SearcherStatus } from '@/components/common/searcher/shared/models/common-searcher.model'
import { PatientSearcherRequestParams } from '@/components/common/searcher/components/patient/patient-searcher.model'
import {
    IdentifierTypeResponse,
    IdentifierTypeScope
} from '@/api/resources/common/initialization/common-initialization.dto'
import { CommonCenterResponse } from '@/api/services/common/center/common-center.dto'
import { PatientSearchRequest, PatientSearchResponse } from '@/api/services/patient/patient/patient.dto'
import { Nullable } from '@/shared/types/app.types'
import { ModalUtils } from '@/shared/util/modal-utils'

@Component({
    components: {
        PatientSearcherComponent,
        PatientHeaderCard,
        PatientIdentifiersCard,
        PatientPersonalDataCard,
        PatientAddressInfoCard,
        ModalRepeatedPatients
    }
})
export default class PatientFusionData extends Vue {
    @PropSync('patient', { type: Object }) syncedPatient!: Nullable<PatientSearchResponse>
    @Prop({ type: Array, default: () => [] }) readonly identifierTypes!: IdentifierTypeResponse[]
    @Prop({ type: Array, default: () => [] }) readonly centers!: CommonCenterResponse[]

    @Ref() readonly patientSearcher!: any
    @Ref() readonly modalRepeatedPatients!: any

    state: PatientFusionDataState
    constructor() {
        super()
        this.state = initialPatientFusionDataState()
    }

    focus(): void {
        this.patientSearcher?.focus()
    }

    changePatient(patient: PatientSearchResponse): void {
        this.syncedPatient = patient
    }

    async searcher(searcherParams: PatientSearcherRequestParams): Promise<PatientSearchResponse[]> {
        const { identifierType, center, id } = searcherParams
        const params: PatientSearchRequest = {
            id,
            identifierType: identifierType?.code
        }
        if (identifierType?.idtScope === IdentifierTypeScope.CENTER_PATIENT) {
            params.centerCode = center?.code
        }
        this.state.searchedId = id

        const response =
            await PromiseUtils.toCallSecure(
                patientResource.paginator(params))
        return response?.content ?? []
    }
    async onSearched(patients: PatientSearchResponse[]): Promise<void> {
        if (patients.length) {
            if (patients.length === 1) {
                this.changePatient(patients[0])
            } else {
                this.modalRepeatedPatients.show(patients, this.state.searchedId)
            }
        }
    }
    onSearchStatusChanged(status: SearcherStatus): void {
        switch (status) {
        case SearcherStatus.ERROR:
            ModalUtils.showErrorModal(this.$tc('component.modalError.title'))
            break
        case SearcherStatus.NO_RESULTS:
            ModalUtils.showErrorModal(this.$tc('registry.caseGrid.search.noPatient'))
            break
        case SearcherStatus.TOO_MANY_RESULTS:
            ModalUtils.showErrorModal(this.$tc('component.patient.searcher.tooManySearchResults'))
            break
        case SearcherStatus.INVALID_IDENTIFIER:
            ModalUtils.showErrorModal(this.$tc('component.searcher.error.validIdentifier'))
            break
        case SearcherStatus.SEARCH_CLEARED:
            this.state.searchedId = ''
            break
        }
    }
}
